import { SHADOW_CALCULATION_WARNING } from '../../../shared/shadowCalculationWarning';
import { APPROVAL_NOT_MONEY_MOVEMENT_NOTE } from '../reviewCopy';

/** Always shown on the run detail: the existing shadow/unverified calculation warning (shared wording, same
 * markup Custom Pay Run's Calculate step uses) plus the approved "approval is not a money movement" note.
 * Deliberately has no controls and links nowhere — nothing here, or anywhere in Payroll Review, can transmit a
 * direct deposit, tax payment, tax deposit or tax filing. */
export function ReviewSafetyNotice() {
  return (
    <div className="payroll-review__safety" role="note" aria-label="Payroll review safety notice">
      <p className="badge badge--warning">{SHADOW_CALCULATION_WARNING}</p>
      <p className="muted">{APPROVAL_NOT_MONEY_MOVEMENT_NOTE}</p>
    </div>
  );
}
